import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fpar-card',
  templateUrl: './fpar-card.component.html',
  styleUrls: ['./fpar-card.component.scss'],
  standalone: false,
})
export class FparCardComponent {
  @Input() cardIcon: string;
  @Input() cardTitle: string;
  @Input() cardSubTitle: string;
  @Input() cardLinkIcon: string;
  @Input() cardLinkUrl: string;
  @Input() cardLinkText: string;
  @Input() buttonType: string;
  @Input() showButtonIcon: boolean;
}
